import { queryBuilder } from '@inpart-io/devtools-iap';
import { RETRIEVE_BY_QUERY } from '@inpart-io/devtools-vue';
import { type IPrivateContactAgreement } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { RECEIVE_BY_AGREEMENT } from './mutations';

export const STORE_BY_AGREEMENT = 'storeByAgreement';
export const RETRIEVE_BY_AGREEMENT = 'retrieveByAgreement';

export const actions: ActionTree<IPrivateContactAgreement, unknown> = {
    async [RETRIEVE_BY_AGREEMENT](context, { agreementId, properties }: { agreementId: number; properties?: string }): Promise<number[]> {
        const idList = await context.dispatch(RETRIEVE_BY_QUERY, {
            query: queryBuilder.build(queryBuilder.op.and(queryBuilder.cmp.refersTo('agreement', agreementId))),
            properties
        });
        context.commit(RECEIVE_BY_AGREEMENT, { agreementId, idList });
        return idList;
    },
    [STORE_BY_AGREEMENT](context, { agreementId, idList }: { agreementId: number; idList: number[] }): void {
        context.commit(RECEIVE_BY_AGREEMENT, { agreementId, idList });
    }
};
